<template>
  <div class="flex flex-1 flex-col">
    <section class="border-b border-slate-200 bg-white">
      <div class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <h1 class="text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
          Meist
        </h1>
        <p class="mt-3 max-w-2xl text-base text-slate-600 sm:text-lg">
          Saurusrehv OÜ – rehvitööd ning rehvide taastamine ja remont Tartus.
        </p>
      </div>
    </section>

    <div
      class="mx-auto w-full max-w-7xl space-y-8 px-4 py-12 sm:px-6 lg:px-8 lg:py-16"
    >
      <section class="grid gap-8 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)]">
        <article
          class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
        >
          <h2 class="text-xl font-bold tracking-tight text-ink">Meie lugu</h2>
          <div class="mt-4 space-y-4 text-base leading-relaxed text-slate-600">
            <p>
              Saurusrehv OÜ asutaja Aivo Kade hakkas veoautorehvidega tegelema
              aastast 1991.
            </p>
            <p>
              Soomes saadud väljaõpe veoauto rehvide taastamises ning Saksamaal
              kogutud kogemus veoauto-, traktori- ja tööstusrehvide remontimises
              tagavad kindla professionaalsuse.
            </p>
            <p>
              Kuulame igapäevaselt klientide tagasisidet ja testime rehve
              erinevates tingimustes, et pakkuda töökindlaid lahendusi.
            </p>
            <p>
              Rehvitööd teostame kohapeal, taastamise teeme koostööpartnerite
              kaudu.
            </p>
          </div>
        </article>

        <aside
          class="flex flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
          aria-labelledby="contact-heading"
        >
          <h2 id="contact-heading" class="text-xl font-bold tracking-tight text-ink">
            Kontakt
          </h2>
          <ul class="mt-4 space-y-3 text-base text-slate-700">
            <li class="flex items-start gap-3">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-600"
              >
                <svg
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.75"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
                  />
                </svg>
              </span>
              <div>
                <p class="text-xs font-medium uppercase tracking-wide text-slate-500">
                  Aadress
                </p>
                <p class="font-medium text-ink">Selli tn 3, 50113 Tartu</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <span
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-600"
              >
                <svg
                  class="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.75"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                  />
                </svg>
              </span>
              <div>
                <p class="text-xs font-medium uppercase tracking-wide text-slate-500">
                  E-post
                </p>
                <a
                  href="mailto:saurusrehv@gmail.com"
                  class="font-medium text-brand-600 hover:text-brand-700 hover:underline"
                  >saurusrehv@gmail.com</a
                >
              </div>
            </li>
          </ul>
          <div
            class="mt-6 flex-1 overflow-hidden rounded-xl border border-slate-200"
          >
            <iframe
              class="h-64 w-full border-0 sm:h-72 lg:h-full lg:min-h-[280px]"
              title="SaurusRehv asukoht kaardil"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2093.634734322551!2d26.733310577756082!3d58.34896347415445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eb37345e4baff3%3A0xb80556ade11633c2!2sSAURUSREHV%20O%C3%9C!5e0!3m2!1set!2sse!4v1741955914124!5m2!1set!2sse"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </aside>
      </section>

      <section class="grid gap-6 md:grid-cols-2">
        <article
          class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
        >
          <h2 class="text-lg font-semibold text-ink">Kogemus ja kvaliteet</h2>
          <p class="mt-3 text-base leading-relaxed text-slate-600">
            Pidev püsiklientide kasv on parim tunnustus meie tööle.
            Usaldusväärsed partnerid ja kaasaegsed töövõtted tagavad
            sõidukitele turvalised rehvilahendused.
          </p>
        </article>

        <article
          class="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
        >
          <h2 class="text-lg font-semibold text-ink">Meie väärtused</h2>
          <p class="mt-3 text-base leading-relaxed text-slate-600">
            Hindame selget suhtlust, kiiret tagasisidet ja läbipaistvat
            hinnastust. Oleme partner, kellele saad loota nii hooajalisel
            rehvitööl kui ka keerukamate lahenduste puhul.
          </p>
        </article>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",
};
</script>
